// extracted by mini-css-extract-plugin
export default {"details":"DetailModal_details__LR2Qi","description":"DetailModal_description__rYowU"};